<template>
  <v-menu offset-y :nudge-bottom="10" open-on-hover open-delay="300">
    <template #activator="{ on, attrs }">
      <a
        class="history-button primary--text font-weight-light"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon color="primary">history</v-icon>
        History
      </a>
    </template>
    <v-card class="pt-1">
      <event-log
        :reference="reference"
        :event-logs="duplicateEventLogs"
        no-background
        no-empty-state
      />
    </v-card>
  </v-menu>
</template>

<script>
import EventLog from '@/components/EventLog/EventLog';
import { Reference } from '@/models';
import { ReferenceEvent } from '@/enums';

export default {
  name: 'DuplicateEventHistoryPopup',
  components: { EventLog },
  props: {
    reference: {
      type: Reference,
      required: true,
    },
  },
  computed: {
    duplicateEventLogs() {
      return this.reference.eventLogs.filter(
        (eventLog) =>
          eventLog.event === ReferenceEvent.DUPLICATE_STATE_UPDATE
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.history-button {
  user-select: none;
}
</style>
